module.exports = __webpack_public_path__ + "static/media/orangina@2x.b9ffd644.png";